export default class AirQualitySummary {
  constructor(element) {
    this.el = element
    this.tablist = this.el.querySelector('[role="tablist"')
    this.station = this.el.dataset.station
    this.locale = this.el.dataset.locale ? this.el.dataset.locale : 'fr'
    this.isDataFetched = false
    this.errorEl = this.el.querySelector('.js-tab-summary-error')
    this.loaderEl = this.el.querySelector('.js-tab-summary-loader')

    if (this.station) {
      this.yearList = this.el.querySelector('.js-tab-summary-year-select')
      this.tabpanel = ''
      this.init()
    }
  }

  init() {
    this.tablist.addEventListener('TabChange', this.handleTabChange.bind(this))

    if (this.yearList) {
      this.year = this.yearList[0].value
      this.yearList.addEventListener('change', this.handleYearChange.bind(this))
    }
  }

  async handleTabChange(event) {
    const tab = event.detail.tab
    this.tabpanel = event.detail.tabpanel
    if (tab.classList.contains('js-tab-summary') && !this.isDataFetched) {
      this.updateAirQualitySummary()
      this.isDataFetched = true
    }
  }

  async handleYearChange(event) {
    this.year = event.target.value
    this.updateAirQualitySummary()

    const tabPolite = this.tabpanel.querySelector('.js-tab-summary-polite')
    if (tabPolite && this.year) {
      tabPolite.innerHTML = this.year
    }
  }

  async updateAirQualitySummary() {
    try {
      const tabContent = this.tabpanel.querySelector('.js-tab-summary-content')
      tabContent.style.display = 'block'
      this.errorEl.style.display = 'none'
      this.showLoader()
      const history = await this.fetchAirQualitySummary()
      if (history) {
        this.updateTabContent(history)
      }
      this.loaderEl.classList.add('hidden')
    } catch (error) {
      this.handleError()
      this.loaderEl.classList.add('hidden')
    }
  }

  async fetchAirQualitySummary() {
    const response = await fetch(
      `${window.location.origin}/wp-json/api/v1/air-quality/${this.station}/history?year=${this.year}&locale=${this.locale}`,
      {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      },
    )

    const responseJson = await response.json()

    if (!responseJson.success) {
      throw new Error('API_ERROR')
    }

    return responseJson.data[0]
  }

  async updateTabContent(data) {
    const tabText = this.tabpanel.querySelector('.js-tab-summary-text')
    if (tabText && data.under_norm_text) {
      tabText.innerHTML = data.under_norm_text
    }

    const tabTable = this.tabpanel.querySelector('.js-tab-summary-table')
    if (tabTable && data.history_table && data.history_table.length > 0) {
      let tableCaption = tabTable.dataset.caption
        ? '<caption class="visuallyhidden">' +
          tabTable.dataset.caption +
          '</caption>'
        : ''

      tabTable.innerHTML = tableCaption + this.getTableContent(data)
    }

    const tabComments = this.tabpanel.querySelector('.js-tab-summary-comments')
    const tabCommentsList = this.tabpanel.querySelector(
      '.js-tab-summary-comments ul',
    )
    if (tabCommentsList && data.comments && data.comments.length > 0) {
      tabCommentsList.innerHTML = this.getCommentsContent(data)
      tabComments.style.display = 'block'
    }
  }

  getTableContent(data) {
    const tabTable = data.history_table.map((item, index) => {
      let tbody = ''
      if (index == 0) {
        return `
          <thead>
            <tr>
              <th scope="col" role="columnheader">${item.label}</th>
              <th scope="col" role="columnheader">${item.value}</th>
            </tr>
          </thead>
        `
      } else {
        if (index == 1) {
          tbody = '<tbody>'
        }

        tbody += `
          <tr>
            <td>${item.label}</td>
            <td>${item.value}</td>
          </tr>
        `

        if (index == data.history_table.length - 1) {
          tbody += '</tbody>'
        }

        return tbody
      }
    })

    return tabTable.join('')
  }

  getCommentsContent(data) {
    const tabComments = data.comments.map(
      (item) =>
        `<li role="listitem"><span>${item.date}&nbsp;:</span><span>${item.comment}</span></li>`,
    )

    return tabComments.join('')
  }

  handleError() {
    const tabContent = this.tabpanel.querySelector('.js-tab-summary-content')
    tabContent.style.display = 'none'
    this.errorEl.style.display = 'block'
  }

  showLoader() {
    this.loaderEl.classList.remove('hidden')
    const tabText = this.tabpanel.querySelector('.js-tab-summary-text')
    if (tabText) {
      tabText.innerHTML = ''
    }

    const tabTable = this.tabpanel.querySelector('.js-tab-summary-table')
    if (tabTable) {
      tabTable.innerHTML = ''
    }

    const tabComments = this.tabpanel.querySelector('.js-tab-summary-comments')
    if (tabComments) {
      tabComments.style.display = 'none'
    }
  }
}
